import { HTMLAttributes, PropsWithChildren } from 'react';
import { VariantProps } from 'tailwind-variants';
import { headingStyles } from './styles';

type IHeadingVariants = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
export interface IHeadingProps
  extends HTMLAttributes<HTMLHeadingElement>,
    VariantProps<typeof headingStyles> {
  variant?: IHeadingVariants;
}

export function Heading({
  bold,
  children,
  className,
  design,
  italic,
  size,
  underline,
  variant: HeadingTag = 'h1',
  ...rest
}: PropsWithChildren<IHeadingProps>): JSX.Element {
  return (
    <HeadingTag
      className={headingStyles({
        size: size || HeadingTag,
        className,
        design,
        bold,
        italic,
        underline,
      })}
      {...rest}
    >
      {children}
    </HeadingTag>
  );
}
